import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import ShowroomForm from "components/form/ShowroomForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Showroom modificato con successo",
        errorMsg: "Errore nella modifica dello showroom",
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function ModificaShowroom() {
    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Showroom</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ShowroomForm />

                <ButtonSave />
            </SaveContextProvider>
        </>
    );
}

export default ModificaShowroom;
